import {withStyles} from '@material-ui/core';
import Notification, {
    NActionButton,
    TOP_RIGHT_POSITION,
    TOP_LEFT_POSITION,
    BOTTOM_LEFT_POSITION,
    BOTTOM_RIGHT_POSITION,
    TOP_CENTER_POSITION,
    BOTTOM_CENTER_POSITION,
    DEFAULT_TYPE,
    ERROR_TYPE,
    SUCCESS_TYPE,
} from './Notification';
import styles from './styles';

export {
    TOP_RIGHT_POSITION,
    TOP_LEFT_POSITION,
    BOTTOM_LEFT_POSITION,
    BOTTOM_RIGHT_POSITION,
    TOP_CENTER_POSITION,
    BOTTOM_CENTER_POSITION,
    DEFAULT_TYPE,
    ERROR_TYPE,
    SUCCESS_TYPE,
    NActionButton
};

export default withStyles(styles)(Notification);
